const HIDE_WHEN_ZERO_FEE_ITEMS = ['DSP保证金', 'DSP保险费'];

// 后端返回已格式化的无符号金额字符串（如 "$ 0.00"），也兼容 number
const isZeroAmount = (amount: number | string | null | undefined): boolean => {
  if (amount == null || amount === '') return true;
  const parsed = typeof amount === 'number' ? amount : parseFloat(String(amount).replace(/[^0-9.-]/g, ''));
  return Number.isNaN(parsed) || parsed === 0;
};

export function hideZeroDepositInsuranceRows<
  T extends { feeItemName?: string | null; totalAmount?: number | string | null },
>(rows: T[]): T[] {
  return rows.filter(
    (r) =>
      !(
        r.feeItemName != null &&
        HIDE_WHEN_ZERO_FEE_ITEMS.includes(r.feeItemName) &&
        isZeroAmount(r.totalAmount)
      ),
  );
}
